import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { ListMenu } from "../../theme/Component/ListMenu";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { SelectAdquisitionContract } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { _CostStudy } from "../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../theme/Input/InputDate";
interface Props {
   
    idSelector?: number;
    onChange?: any;
    label?: string;
}


export const CostStudy = ({ onChange }: Props) => {

    const coststudy = useDataBean(_CostStudy);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    // useEffect(() => {
    //     onChange(coststudy.bean);
    // }, [coststudy.bean])

    const getLista = () => {

        coststudy.instance.getCostStudyCatalogPorPropiedades({State:1},null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        coststudy.setBean({
            State: 1,
            Since:_single.getCurrenDate(),
            IDEmployee:_single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        coststudy.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }
    const editaItem = () => {
       //console.log(entailment.bean);
       coststudy.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCostStudy', visible: true },
        { title: 'Fecha del estudio de costos', property: 'Date', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Contrato', property: 'IDAdquisitionContract', visible: true },
        { title: 'Partida Arancelaria del estudio', property: 'TariffItem', visible: true },
        { title: 'Valor del estudio de costos', property: 'ValueCostStudy', visible: true },
        { title: 'Observaciones finales', property: 'Observations', visible: true },
        { title: 'Fecha del registro', property: 'Since', visible: true },
        { title: 'Perona que registra el estudio de costos', property: 'IDEmployee', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${coststudy.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Costos de Estudio">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={coststudy.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                    
                    <div className="col-md-6">
                    <label>Valor del estudio de costos</label>
                    <input type="text" name="ValueCostStudy" className="form-control" value={coststudy.bean.ValueCostStudy} onChange={coststudy.handleChange} />
                    </div>
                            <div className="col-md-6">
                                 <InputDate name="Date" label="Fecha del estudio de costos" value={coststudy.bean.Date} setDate={(e: any) => { coststudy.setBean({ ...coststudy.bean, "Date": e }) }} />
                            </div>
                            <div className="col-md-12">
                        <SelectAdquisitionContract data={{IDAccount:coststudy.bean.IDAccount}} idSelector={coststudy.bean.IDAdquisitionContract} onChange={({DataBeanProperties}) => { coststudy.setBean({ ...coststudy.bean, 'IDAdquisitionContract': DataBeanProperties.IDAdquisitionContract }) }} />
                    </div>
                    <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="Observations" className="form-control" value={coststudy.bean.Observations} onChange={(e) => { coststudy.setBean({ ...coststudy.bean, 'Observations': e.target.value }) }} />
                        </div>
                        <div className="col-md-12">
                        <label>Partida Arancelaria del estudio</label>
                        <input type="text" name="TariffItem" className="form-control" value={coststudy.bean.TariffItem} onChange={coststudy.handleChange} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={coststudy.bean.Description} onChange={(e) => { coststudy.setBean({ ...coststudy.bean, 'Description': e.target.value }) }} />
                        </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {coststudy.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}